import React from 'react';

/**
 * Professional empty state — used across every Accounting page for
 * consistent visual language when a table/list has no rows.
 */
export default function EmptyState({ icon: Icon, title, description, action, dataTestId }) {
  return (
    <div className="p-16 flex flex-col items-center justify-center text-slate-500" data-testid={dataTestId || 'empty-state'}>
      {Icon && <Icon className="h-12 w-12 text-slate-300 mb-4" />}
      <div className="text-sm font-medium text-slate-700 mb-1">{title}</div>
      {description && <div className="text-xs text-slate-500 text-center max-w-md">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
